import { create } from 'zustand';

/**
 * Open state of the wallet dialogs mounted by `HeaderV2Container` (deposit /
 * converter). Global so any zone can open them without navigating to
 * `/account` — e.g. the trade-zone margin-call toast.
 */
interface WalletDialogsState {
  depositOpen: boolean;
  convertOpen: boolean;
  setDepositOpen: (open: boolean) => void;
  setConvertOpen: (open: boolean) => void;
}

export const useWalletDialogsStore = create<WalletDialogsState>((set) => ({
  depositOpen: false,
  convertOpen: false,
  setDepositOpen: (depositOpen) => set({ depositOpen }),
  setConvertOpen: (convertOpen) => set({ convertOpen }),
}));
